export function getValidData<T extends Record<string, unknown> = Record<string, unknown>>(data: T) {
  let newData: Record<string, unknown> = {};

  function updateData(key: string, value: unknown) {
    newData = {
      ...newData,
      [key]: value,
    };
  }

  Object.entries(data).forEach(([key, value]) => {
    const length = (value as { length?: number })?.length;
    if (value === undefined || (length !== undefined && length <= 0)) return;
    if (typeof value === 'string' && value.length > 0) {
      updateData(key, value);
    }
    if (Array.isArray(value) && value.length > 0) {
      updateData(key, value);
    }
    if (value !== undefined && value !== null && !Array.isArray(value)) {
      updateData(key, value);
    }
  });

  return newData as T;
}
